import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

interface LayoutProps {
  user: {
    name: string;
    email: string;
    avatar?: string;
    role: string;
  } | null;
  title?: string;
}

export function Layout({ user, title }: LayoutProps) {
  const isAdmin = user?.role === 'admin';

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--background-main)' }}>
      {/* サイドバー */}
      <Sidebar isAdmin={isAdmin} />

      {/* メインコンテンツエリア */}
      <div className="ml-[170px]">
        {/* ヘッダー */}
        <Header 
          title={title} 
          user={user}
          notificationCount={3}
        />

        {/* ページコンテンツ */}
        <main className="pt-16 min-h-screen">
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
